import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'qubCommon/Other/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import PublicLayout from 'layout/PublicLayout';
import { useSettings } from 'hooks/useSettings';
import { PublicClubView } from 'views/public/Clubs';
import { PublicAthletesView } from 'views/public/Athletes';
import { PublicOffialsView } from 'views/public/Officials';
import Register from 'views/authentication/register';
import Join from 'views/authentication/join';
import MainLayout from 'layout/MainLayout';
import MemberHome from 'views/member/Home';
import PageNotFound from 'views/PageNotFound';
import Profile from 'views/member/Profile';
import PaymentSubmittion from 'views/application/Payments/Submittion';
import PaymentResultPage from 'views/application/Payments/Submittion/paymentMethod/byCard/form/resultPage';
import MemberTransactions from 'views/member/Transactions';
import ClubHome from 'views/club/Home';
import ClubProfile from 'views/club/ClubProfile';

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const MemberRoutes = () => {
    // eslint-disable-next-line camelcase
    const { project_public_enabled, project_member_reg_enabled } = useSettings();

    return [
        {
            path: '/',
            element: <MainLayout />,
            children: [
                { path: 'home', element: <MemberHome /> },
                { path: 'home2', element: <ClubHome /> },
                { path: 'my-transactions', element: <MemberTransactions /> },
                {
                    path: 'profile/:personId?',
                    element: <Profile />
                },
                {
                    path: 'club-profile/:id?',
                    element: <ClubProfile />
                },
                {
                    path: '',
                    element: <Navigate to="/home" />
                },
                {
                    path: '*',
                    element: <PageNotFound />
                }
            ]
        },
        {
            path: '',
            element: <MinimalLayout />,
            children: [
                {
                    path: 'payment/:token',
                    element: <PaymentSubmittion />
                },
                {
                    path: 'api/payment/success',
                    element: <PaymentResultPage />
                },
                {
                    path: 'api/payment/fail',
                    element: <PaymentResultPage />
                },
                {
                    path: '',
                    element: <Navigate to="/home" />
                },
                {
                    path: '*',
                    element: <PageNotFound />
                }
            ]
        },
        {
            path: '',
            element: <Navigate to="/home" />
        },
        {
            path: '*',
            element: <PageNotFound />
        }
    ];
};
export default MemberRoutes;
